// extracted by mini-css-extract-plugin
module.exports = {"container":"emptyBookings_container__34TFG","text":"emptyBookings_text__3MP_t","nextAvailable":"emptyBookings_nextAvailable__2d5ES","date":"emptyBookings_date__RM8Yg"};